import { useMemo, useState } from 'react';
import { UiButton, UiInput } from '@shared/common/ui';

export function HallFreeSeats({ selectedSeats, setSeats, eventData, value }) {
  const [fio, setFio] = useState('');
  const [error, setError] = useState('');

  const soldTickets = useMemo(() => {
    return (Array.isArray(value) ? value : [])
      .flatMap((order) =>
        (order.tickets || []).map((ticket) => ({
          ...ticket,
          fio: order?.fio || ticket?.fio || '',
          orderId: order?.id,
          orderNumber: order?.number,
        })),
      )
      .sort((a, b) =>
        String(a?.fio ?? '').localeCompare(String(b?.fio ?? ''), 'ru', { sensitivity: 'base' }),
      );
  }, [value]);

  const maxCountSeats = Number(eventData?.maxCountSeats) || 0;
  const freeSeatPrice = eventData?.prices?.[0] || 0;
  const totalTaken = soldTickets.length + (selectedSeats?.length || 0);
  const canAdd = maxCountSeats === 0 || totalTaken < maxCountSeats;

  const addTicket = () => {
    const name = fio.trim();
    if (!name) {
      setError('Укажите ФИО');
      return;
    }
    const list = [...(selectedSeats || [])];
    const existsSelected = list.some((x) => x?.fio?.toLowerCase() === name.toLowerCase());
    const existsSold = soldTickets.some((x) => x?.fio?.toLowerCase() === name.toLowerCase());
    if (existsSelected || existsSold) {
      setError('Билет на это имя уже куплен');
      return;
    }
    list.push({ fio: name, price: freeSeatPrice, type: 'free_seats' });
    setSeats(list);
    setFio('');
    setError('');
  };

  const exportList = () => {
    if (soldTickets.length === 0) return;
    const header = ['№', 'ФИО'];
    const rows = soldTickets.map((t, ind) => [ind + 1, t.fio ?? '']);
    const csv = [header, ...rows]
      .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(';'))
      .join('\n');
    const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${eventData?.name || 'event'}-list.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="hall-free">
      <div className="hall-free__count">
        Свободная посадка: {soldTickets.length}
        {maxCountSeats ? `/${maxCountSeats}` : ''} мест
      </div>

      {canAdd && (
        <div className="hall-free__add">
          <UiInput
            label="ФИО"
            value={fio}
            onChange={(e) => {
              setFio(e.target.value);
              if (error) setError('');
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                addTicket();
              }
            }}
            error={error}
            placeholder="Иванов Иван"
          />
          <UiButton type="button" onClick={addTicket}>
            Добавить
          </UiButton>
        </div>
      )}

      <div className="hall-free__toolbar">
        <UiButton type="button" variant="ghost" onClick={exportList} disabled={soldTickets.length === 0}>
          Экспорт списка
        </UiButton>
      </div>

      {soldTickets.length > 0 ? (
        <ol className="hall-free__list">
          {soldTickets.map((t, ind) => (
            <li key={t.orderId ? `${t.orderId}-${ind}` : `${t.orderNumber}-${ind}`}>{t.fio}</li>
          ))}
        </ol>
      ) : (
        <div className="muted">Проданных билетов пока нет.</div>
      )}
    </div>
  );
}
